import React from 'react';
import { useTranslation } from 'next-i18next';

import Title from '@/components/Title';

const Banner = () => {
  const { t } = useTranslation('contactUs');
  return (
    <div className="relative h-[482px] overflow-hidden bg-[url('/images/contactUs/banner-phone.png')] bg-cover bg-center bg-no-repeat lg:h-[335px] lg:bg-[url('/images/contactUs/banner.png')] xl:h-[460px]">
      <div className="relative z-10 mx-auto mt-[120px] px-10 text-center text-wk-words-2 lg:mt-[153px] lg:w-[848px] lg:px-0 lg:text-left xl:mt-[205px] xl:w-[1164px]">
        <Title theme="colorful" className="lg:[&]:text-left">
          <span dangerouslySetInnerHTML={{ __html: t('bannerTitle') }} />
        </Title>
        <p className="mt-3 text-[14px] lg:mt-4 lg:text-[16px] xl:mt-6 xl:text-[20px]">{t('bannerDescription')}</p>
      </div>
    </div>
  );
};

export default Banner;
